import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  searchPhrase: '',
  searchResults: null,
  searchTotalResults: 0,
  searchLoading: false
}

const SearchModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async querySearchSuggestions ({ commit, state, getters, rootGetters }, { suggestQueryString }) {
      state.searchPhrase = suggestQueryString
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.query({
        query: gql`query suggest ($suggestQuery: String!) {
          suggest (suggestQuery: $suggestQuery) {
            suggestContent {
              image
              title
              url
              group
              info
            }
          }
        }`,
        variables: {
          suggestQuery: suggestQueryString
        }
      }).then((result) => {
        return result.data?.suggest?.suggestContent || []
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    },
    async querySearch ({ commit, state, getters, rootGetters }, { searchQuery, start, rows }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      state.searchLoading = true
      return apolloClient.query({
        query: gql`query search ($searchQuery: String!, $start: Int!, $rows: Int!) {
          search (searchQuery: $searchQuery, start: $start, rows: $rows) {
            searchContent {
              image
              title
              url
              content
              description
            }
            total
          }
        }`,
        variables: {
          searchQuery: searchQuery,
          start: start,
          rows: rows
        }
      }).then((result) => {
        const search = result.data?.search || { searchContent: [], total: 0 }
        if (start > 1) {
          state.searchResults = state.searchResults.concat(search.searchContent)
        } else {
          state.searchResults = search.searchContent ? search.searchContent : []
          state.searchTotalResults = search.total ? search.total : 0
        }
        state.searchLoading = false
        return true
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        state.searchLoading = false
        return false
      })
    }
  },
  mutations: {
    setSearchPhrase (state, searchPhrase) {
      state.searchPhrase = searchPhrase
      state.searchResults = null
      state.searchTotalResults = 0
    },
    resetState (state) {
      state.searchPhrase = ''
      state.searchResults = null
      state.searchTotalResults = 0
    }
  },
  getters: {
    searchPhrase: state => state.searchPhrase,
    searchResults: state => state.searchResults,
    searchTotalResults: state => state.searchTotalResults,
    searchLoading: state => state.searchLoading
  }
}

export {
  SearchModule
}
